"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookmarksProvider = exports.BookmarksContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var BookmarksContext = exports.BookmarksContext = /*#__PURE__*/(0, _react.createContext)();
var BookmarksProvider = _ref => {
  var {
    children
  } = _ref;
  var [bookmarks, setBookmarks] = (0, _react.useState)([]);
  var [isPageBookmarked, setIsPageBookmarked] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(BookmarksContext.Provider, {
    value: {
      bookmarks,
      setBookmarks,
      isPageBookmarked,
      setIsPageBookmarked
    }
  }, children);
};
exports.BookmarksProvider = BookmarksProvider;
BookmarksProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};